import { AnyAction } from 'redux';
import {
  AdressvorschlagPayload,
  CALLER_ID,
  CommonInsuranceData,
  GlobalActions,
} from '@ps20-frontend/shop-integration-redux';
import { App, BasisAdresse, ThhPferdVorbelegungdaten } from '@ps20-frontend/frontend-models';
import { ThhPferdActions } from '../thhPferdActions';

export const risikoortReducer = function (
  sectionState: BasisAdresse = null,
  action: AnyAction,
): BasisAdresse {
  switch (action.type) {
    case ThhPferdActions.PLZ_CHANGED: {
      const plz = action.payload;
      return {
        plz,
        strasse: '',
        hausnummer: '',
        ort: '',
      };
    }
    case GlobalActions.ADDRESSVORSCHLAG_SUCCESSFUL: {
      const payload: AdressvorschlagPayload = action.payload;
      if (payload.callerId !== CALLER_ID.THH_PFERD_BASISDATEN) {
        return sectionState;
      }
      if (payload.orte?.length === 1) {
        const newState: BasisAdresse = { ...sectionState };
        newState.ort = payload.orte[0];
        return newState;
      }
      return sectionState;
    }
    case ThhPferdActions.ORT_CHANGED: {
      return { ...sectionState, ort: action.payload };
    }
    case ThhPferdActions.STRASSE_CHANGED: {
      return { ...sectionState, strasse: action.payload };
    }
    case ThhPferdActions.HAUSNUMMER_CHANGED: {
      return { ...sectionState, hausnummer: action.payload };
    }
    case GlobalActions.EINSTIEG_REQUEST_SUCCESSFUL: {
      const risikoort: BasisAdresse = action.payload.versicherungsnehmer.adresse;
      return {
        ...sectionState,
        plz: risikoort.plz,
        strasse: risikoort.strasse,
        ort: risikoort.ort,
        hausnummer: risikoort.hausnummer,
      };
    }
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED: {
      const actionPayload: ThhPferdVorbelegungdaten = action.payload;
      if (actionPayload.forApp === App.THH_PFERD) {
        return {
          ...sectionState,
          plz: actionPayload.vnAdresse?.plz,
          strasse: actionPayload.vnAdresse?.strasse,
          hausnummer: actionPayload.vnAdresse?.hausnummer,
          ort: actionPayload.vnAdresse?.ort,
        };
      }
      return sectionState;
    }
    case GlobalActions.EINSTIEG_WITH_INVALID_ADDRESS: {
      return {
        ...sectionState,
        invalidAddress: true,
      };
    }
    case GlobalActions.COMMON_INSURANCE_DATA_RECEIVED: {
      const payload = action.payload as CommonInsuranceData;
      return {
        ...sectionState,
        invalidAddress: payload.vnInvalidAddress,
      };
    }
    default:
      return sectionState;
  }
};
